import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { SelectableOnOpenDirective } from 'src/app/core/directives/selectable-on-open.directive'
import { IInputDialogOptions } from 'src/app/core/interfaces/modal.interface'
import { MatButtonModule } from '@angular/material/button'


@Component({
  selector: 'admin-input-dialog-component',
  template: `
    @if (data.title) {
      <div mat-dialog-title class="dialog__title">{{data.title}}</div>
    }
    <mat-dialog-content class="dialog__content">
      @for (input of data.inputs; track input; let last = $last) {
        @if (input.type === 'text') {
          <mat-form-field [class.no-padding]="last">
            @if (input.label) {
              <mat-label>{{input.label}}</mat-label>
            }
            <input
              matInput
              type="text"
              selectableOnOpen
              [selectOnOpen]="!!input.selectedOnOpen"
              [defaultValue]="input.defaultValue"
              (change)="input.change($event); validate();"
              (keyup)="input.change($event); validate();"
              (keydown.enter)="submitOnEnter()" />
          </mat-form-field>
        }
      }
    </mat-dialog-content>
    <mat-dialog-actions class="dialog__actions">
      <button [matButton]="'outlined'" mat-dialog-close [mat-dialog-close]="'cancel'">{{data.cancelLabel}}</button>
      <button [matButton]="'elevated'" mat-dialog-close [mat-dialog-close]="'confirm'" [disabled]="!submitIsEnabled">{{data.confirmLabel}}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['../../../../assets/admin.scss'],
  styles: [`
    :host {
      display: block;
    }

    .no-padding {
      margin-bottom: -1.25em !important;
    }
  `],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    SelectableOnOpenDirective,
    MatButtonModule,
  ],
})
export class AdminInputDialogComponent {
  data = inject<IInputDialogOptions>(MAT_DIALOG_DATA)
  dialogRef = inject<MatDialogRef<AdminInputDialogComponent>>(MatDialogRef)

  submitIsEnabled: boolean = true

  validate(): void {
    if (this.data.validate) {
      this.submitIsEnabled = this.data.validate()
    }
  }

  submitOnEnter(): void {
    if (!this.submitIsEnabled) {
      return
    }
    this.dialogRef.close('confirm')
  }
}
